export const buildChemicalUpsertPayload = (dailyLogId: number, chem: Record<string, any>): Record<string, any> => {
  const toCleanString = (v: unknown): string | undefined => {
    if (v == null) return undefined;
    if (typeof v === "number") return String(v);
    if (typeof v === "string") {
      const trimmed = v.trim();
      return trimmed === "" ? undefined : trimmed;
    }
    return undefined;
  };

  const payload: Record<string, any> = { dailyLogId };

  const fields = [
    "measuredInchesCl2",
    "inchesUsedCl2", 
    "inchesNaOClWithDelivery",
    "lbsCl2",
    "freeResidualPpm",
    "psi",
    "staticValue",
    "pumpingValue",
    "topOffCl2",
    "residual",
    "chemicalNotes"
  ];

  for (const field of fields) {
    const val = toCleanString(chem[field]);
    if (val !== undefined) {
      payload[field] = val;
    }
  }

  if (chem.extraJson && Object.keys(chem.extraJson).length > 0) {
    payload.extraJson = chem.extraJson;
  }

  return payload;
};
